exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stepContainer___f898e h3 {\n  font-size: 20px;\n  margin-top: 0;\n  font-weight: 600;\n}\n.stepContainer___f898e p {\n  font-size: 16px;\n  color: #505050;\n  margin-bottom: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"stepContainer": "stepContainer___f898e"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/common/ui/Tour/styles/Step.module.less
// module id = 1878
// module chunks = 70